import http from "@utils/request";
/**
 * 根据属性内容获取管道信息
 * @param {*} property 
 * @param {*} content 
 * @returns 
 */
export const getPipelineInfo3DByProperty=(property,content)=>http({
  url:"/pipeline/getPipelineInfo3DByProperty",
  method:"POST",
  data:{
    property,content
  }
})